export var DeathCauseEnum;
(function (DeathCauseEnum) {
    DeathCauseEnum["NONE"] = "NONE";
    DeathCauseEnum["DEATHSAVES"] = "DEATHSAVES";
    DeathCauseEnum["CONDITION"] = "CONDITION";
})(DeathCauseEnum || (DeathCauseEnum = {}));
